module.exports = __webpack_public_path__ + "c6d77c681085254fe3a567255dbd2dd9.png";


//////////////////
// WEBPACK FOOTER
// ./images/pics1/3.png
// module id = 285
// module chunks = 0